import {
  Box,
  Button,
  Flex,
  Grid,
  GridItem,
  IconButton,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import Card from "common/components/card/Card";
import React, { useEffect, useState } from "react";
import { fetchImage } from "../../redux/reducers/imageSlice";
import { useDispatch, useSelector } from "react-redux";
import ImageView from "./imageView";
import AddImage from "./addImage";
import { getApi } from "common/services/api";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { putApi } from "common/services/api";
import { AddIcon, CloseIcon } from "@chakra-ui/icons";
import DataNotFound from "common/components/notFoundData";
import { deleteApi } from "common/services/api";
import Spinner from "common/components/spinner/Spinner";
import { toast } from "react-toastify";

const ChangeImage = () => {
  const [imageModal, setImageModal] = useState(false);
  const dispatch = useDispatch();
  const [imageview, setImageView] = useState(false);
  const [imageviewData, setImageViewData] = useState({});
  const [deleteOpen, setDelete] = useState(false);
  const [data, setData] = useState(false);
  const [selectedId, setSelectedId] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchImage());
  }, [dispatch]);

  const fetchData = async (selectedId) => {
    setIsLoading(true);
    let result = await getApi(`api/images/view/${selectedId}`);
    setData(result.data);
    setIsLoading(false);
  };
  const image = useSelector((state) => state?.images?.image);
  const load = useSelector((state) => state?.images);
  const handleViewOpen = (item) => {
    fetchData(item._id);
    setImageView(!imageview);
  };
  const handleViewClose = () => {
    setImageView(false);
  };
  const handleDeleteClose = () => {
    setDelete(false);
  };
  const handleDeleteOpen = (item) => {
    setDelete(!deleteOpen);
    setSelectedId(item._id);
  };

  const handleDelete = async () => {
    try {
      setIsLoading(true);
      let response = await deleteApi(`api/images/delete/`, selectedId);
      if (response.status === 200) {
        dispatch(fetchImage());
        setDelete(false);
        setImageView(false);
      }
    } catch (e) {
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const setImageData = async (item) => {
    try {
      setIsLoading(true);
      let response = await putApi(`api/images/isActive/${item?._id}`, {
        isActive: true,
      });
      if (response.status === 200) {
        handleViewClose();
        dispatch(fetchImage());
      }
    } catch (e) {
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Card>
        <Flex justifyContent={"end"}>
          <Button
            className="shape-default theme-btn1"
            variant="brand"
            size="sm"
            onClick={() => setImageModal(true)}
            leftIcon={<AddIcon />}
          >
            Add New
          </Button>
          <Button
            className="shape-default"
            onClick={() => navigate("/admin-setting")}
            variant="outline"
            size="sm"
            leftIcon={<IoIosArrowBack />}
            ml={2}
          >
            Back
          </Button>
        </Flex>
        {!(load.status === "succeeded") ? (
          <Flex
            justifyContent={"center"}
            alignItems={"center"}
            width="100%"
            color={"black"}
            fontSize="sm"
            fontWeight="700"
          >
            <Spinner />
          </Flex>
        ) : (
          <Card>
            <Grid templateColumns={"repeat(12, 1fr)"} gap={5}>
              {image?.length > 0 &&
                image?.map((item, i) => (
                  <GridItem colSpan={{ base: 12, md: 4, lg: 3 }}>
                    <div className="imageBox">
                      <Image
                        src={item?.authImg}
                        height={"200px"}
                        width={"100%"}
                      />
                      {item?.isActive === true ? (
                        <Box
                          backgroundColor={"#422afb"}
                          color={"#fff"}
                          height={"20px"}
                          width={"140px"}
                          position={"absolute"}
                          top={"18px"}
                          right={"-40px"}
                          transform={"rotate(45deg)"}
                          fontSize={"16px"}
                          display={"flex"}
                          justifyContent={"center"}
                          alignItems={"center"}
                        >
                          Active
                        </Box>
                      ) : (
                        ""
                      )}
                      <div className="imageBoxAction">
                        <Button
                          size="sm"
                          variant="brand"
                          onClick={() => setImageData(item)}
                        >
                          Set Image
                        </Button>
                        <Button
                          size="sm"
                          variant="brand"
                          mx={1}
                          onClick={() => {
                            handleViewOpen(item);
                            setImageViewData(item);
                          }}
                        >
                          View
                        </Button>
                        <Button
                          size="sm"
                          colorScheme="red"
                          disabled={item?.isActive === true ? true : false}
                          onClick={() => {
                            handleDeleteOpen(item);
                          }}
                        >
                          Delete
                        </Button>
                      </div>
                    </div>
                  </GridItem>
                ))}
            </Grid>
            {!image?.length > 0 && (
              <Text
                textAlign={"center"}
                width="100%"
                color={"gray.500"}
                fontSize="sm"
                fontWeight="700"
              >
                <DataNotFound />
              </Text>
            )}
          </Card>
        )}
      </Card>

      <ImageView
        isOpen={imageview}
        onClose={handleViewClose}
        image={image}
        handleDeleteOpen={handleDeleteOpen}
        imageviewData={imageviewData}
        fetchData={fetchData}
        data={data}
        setImageData={setImageData}
      />
      <AddImage
        imageModal={imageModal}
        setImageModal={setImageModal}
        fetchData={fetchImage}
      />
      {/* Delete modal */}
      <Modal onClose={handleDeleteClose} isOpen={deleteOpen} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Delete Images</ModalHeader>
          <IconButton
            size="xs"
            className="closeIcon"
            onClick={handleDeleteClose}
            icon={<CloseIcon />}
          />
          <ModalBody>Are You Sure To Delete selected Images ?</ModalBody>
          <ModalFooter>
            <Button
              className="theme-btn2 cancelBtn"
              variant="outline"
              size="sm"
              onClick={handleDeleteClose}
            >
              No
            </Button>
            <Button
              className="theme-btn3"
              colorScheme="red"
              size="sm"
              ml={4}
              onClick={handleDelete}
              disabled={isLoading ? true : false}
            >
              {isLoading ? <Spinner /> : "Yes"}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ChangeImage;
